import ParkPassAPI from "../parkpassAxiosConfig";

// Get all roles
export const getParkPassRoles = async () => {
  try {
    const response = await ParkPassAPI.get("/v1/roles/roles/");
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get a single role by ID
export const getParkPassRole = async (roleId) => {
  try {
    const response = await ParkPassAPI.get(`/v1/roles/roles/${roleId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Create a new role
export const createParkPassRole = async (roleData) => {
  try {
    const response = await ParkPassAPI.post("/v1/roles/roles/", roleData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update a role
export const updateParkPassRole = async (roleId, roleData) => {
  try {
    const response = await ParkPassAPI.put(`/v1/roles/roles/${roleId}`, roleData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete a role
export const deleteParkPassRole = async (roleId) => {
  try {
    const response = await ParkPassAPI.delete(`/v1/roles/roles/${roleId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get endpoints for a specific role by name
export const getRoleEndpoints = async (roleName) => {
  try {
    const response = await ParkPassAPI.get(`/v1/roles/roles/${roleName}/endpoints`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update endpoints for a specific role by name
export const updateRoleEndpoints = async (roleName, endpoints) => {
  try {
    const response = await ParkPassAPI.put(`/v1/roles/roles/update-endpoints/${roleName}`, { endpoints });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get all available endpoints
export const getAllEndpoints = async () => {
  try {
    const response = await ParkPassAPI.get("/endpoints");
    return response.data;
  } catch (error) {
    throw error;
  }
};
